export default __webpack_public_path__ + "static/media/event.10cc2ec1.jpg";